import { useTranslation } from "react-i18next";

import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { countries } from "./countries";

import "./style.scss";

export default function CountrySelect({ onChange, defaultValue = "" }) {
  const { t } = useTranslation();

  const handleChange = (selectedCountry) => {
    onChange(selectedCountry?.code || "");
  };

  return (
    <div className="country-select">
      <FormControl fullWidth>
        <Autocomplete
          id="country-select"
          size="small"
          options={countries}
          onChange={(event, selectedCountry) => {
            handleChange(selectedCountry);
          }}
          autoHighlight
          getOptionLabel={(option) => option.label}
          {...(!!defaultValue ? { defaultValue } : {})}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return (
              <Box
                key={key}
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...optionProps}
              >
                <img
                  loading="lazy"
                  width="20"
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  alt=""
                />
                {option.label} ({option.code})
              </Box>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("select_country")}
              slotProps={{
                htmlInput: {
                  ...params.inputProps,
                  autoComplete: "new-password",
                },
              }}
            />
          )}
        />
      </FormControl>
    </div>
  );
}
